import { Form, Formik } from "formik";
import React, { FC, ReactElement, useState } from "react";
import { STATIC_DAY_ELEMENT } from "../../../constants/element-type";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useLocale } from "../../../contexts/localeContext";
import { useFilter } from "../../../contexts/table/FilterContext";
import { useTable } from "../../../contexts/table/TableContext";
import WizardSideBarStep from "../../../models/WizardSideBarStep";
import Wizard from "../../wizard/wizard";
import { Category } from "../date-filter/category-step";
import StaticFilterWizard from "../static-filter-wizard";
import { FilterModel } from "../FilterModel";
import { getInactiveForCategory } from "../filterModalUtil";

interface InactiveForFilterWizardProps {
    defaultContent: ReactElement[];
    defaultSteps: WizardSideBarStep[];
    onReset: () => void;
    onClose: () => void;
    filterModalTrigger: string;
}

const InactiveForFilterWizard: FC<InactiveForFilterWizardProps> = ({ onClose, defaultContent, defaultSteps, onReset, filterModalTrigger }) => {
    const { translate } = useLocale();
    const [category, setCategory] = useState<string>("");
    const [categoryName, setCategoryName] = useState<string>(translate.byKey(TranslationKeys.pending));
    const filterContext = useFilter();
    const tableContext = useTable();

    const categoryFilter: FilterModel = { elementSysname: [...STATIC_DAY_ELEMENT], include: true };

    const steps: WizardSideBarStep[] = [
        ...defaultSteps,
        {
            title: translate.byKey(TranslationKeys.filterCategory),
            description: categoryName,
            substeps: [],
        },
    ];

    const handleSubmit = (values: any) => {
        const columnId: any = tableContext.tableDescriptor.find((col) => col.accessor === "inactiveFor")?.id;
        filterContext.updateFilters(columnId, category, categoryName, undefined, category);
        onClose();
    };

    const onNext = (event: any) => {
        setCategory(event.elementSysname);
        setCategoryName(event.name);
    };

    const onLocalReset = () => {
        setCategory("");
        setCategoryName(translate.byKey(TranslationKeys.pending));
    };

    const onBack = (event: any) => {
        if (filterModalTrigger) {
            return;
        }
        onReset();
    };

    const content: ReactElement[] = [
        ...defaultContent,
        <Category
            key={"wizard-2"}
            onBack={onBack}
            onNext={onNext}
            categoryFilter={categoryFilter}
            categoryDataMethod={getInactiveForCategory}
            filterModalTrigger={filterModalTrigger} />
    ];

    const getWizard = () => {
        if (STATIC_DAY_ELEMENT.includes(category)) {
            return <StaticFilterWizard
                defaultContent={content}
                defaultSteps={steps}
                onBack={onLocalReset}
                onClose={onClose}
                selectedCategory={categoryName}
                filterTypeName={translate.byKey(TranslationKeys.inactiveFor)} />
        }

        return <Wizard
            name={translate.byKey(TranslationKeys.dataFilters)}
            step={1}
            onClose={onClose}
            sidebarSteps={steps}>
            {content}
        </Wizard>
    };

    return <Formik
        enableReinitialize={true}
        initialValues={{
            typeElementSysname: "",
            category: "",
            startDate: undefined,
            endDate: undefined,
        }}
        onSubmit={handleSubmit}>
        <Form>
            {getWizard()}
        </Form>
    </Formik>
};

export default InactiveForFilterWizard;
